import { mapPlayerLook } from '@/lib/api/rewards-hub/mappers';
import type { PlayerLookDto } from '@/lib/api/rewards-hub/types';
import type { StrapiCommentVerboseDto } from '@/lib/api/strapi/types';
import type { CommentItem, CommentReaction, CommentReply } from './models';

export function mapReaction(mr?: 'like' | 'dislike' | null): CommentReaction {
  if (mr === 'like') return 'LIKE';
  if (mr === 'dislike') return 'DISLIKE';
  return null;
}

/** strapi-proxy adds the author's Rewards Hub look to every comment and reply (29.09). */
type CommentDto = StrapiCommentVerboseDto & { lk?: PlayerLookDto | null };

export function mapCommentReply(dto: CommentDto): CommentReply {
  return {
    id: String(dto.i),
    content: dto.c ?? '',
    outpollUserId: dto.o ?? '',
    createdAt: dto.ca ?? dto.pb,
    publishedAt: dto.pb,
    author: dto.a ?? '',
    look: mapPlayerLook(dto.lk),
    likesCount: dto.lc ?? 0,
    dislikesCount: dto.dc ?? 0,
    isDeleted: dto.dl ?? false,
    isMine: dto.im ?? false,
    userReaction: mapReaction(dto.mr),
  };
}

export function mapComment(dto: CommentDto): CommentItem {
  return {
    ...mapCommentReply(dto),
    parent: dto.pr ? String(dto.pr) : null,
  };
}
